
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "43b59d464c831af7671fcc2f084e6d41825e006c",
  "nuxt": {
    "buildId": "518bdc20-99b4-44e4-80e4-79f3aa8c1599"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
